const API_URL = process.env.REACT_APP_API_URL || '';

// تحويل حقل الصور في المنشور إلى مصفوفة روابط
// يدعم: null، رابط واحد، أو JSON array string مثل ["/uploads/a.jpg","/uploads/b.jpg"]
export const parseNewsImages = (imageField) => {
  if (!imageField) return [];
  const value = String(imageField).trim();
  if (value.startsWith('[')) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [value];
    } catch {
      return [value];
    }
  }
  return [value];
};

// تحويل رابط نسبي إلى رابط كامل
export const resolveImageSrc = (src) => {
  if (!src) return '';
  if (src.startsWith('http') || src.startsWith('data:')) return src;
  return `${API_URL}${src}`;
};

// جلب الصور الكاملة (بالروابط الكاملة) لمنشور
export const getNewsImageSrcs = (item) => {
  return parseNewsImages(item?.image).map(resolveImageSrc).filter(Boolean);
};

// الصورة الأولى لمنشور (للإستخدام في البطاقات)
export const getNewsCoverSrc = (item) => {
  return getNewsImageSrcs(item)[0] || '';
};
